<template>
  <div class="wrap">
    <div class="complete">
      <div class="container">
        <div class="complete_area">
          <div class="img_area">
            <img src="../assets/images/layout/complete.png" />
            <!-- <img src="../../public/assets/images/layout/complete.png" /> -->
          </div>
          <div class="txt_area">
            <h3>서비스 이용 문의 접수가 완료되었습니다.</h3>
            <!-- <h3>문의하기 접수가 완료되었습니다.</h3> -->
            <p>
              작성한 내용의 답변은 남겨주신 연락처(이메일, 전화번호)로<br />
              빠른 시간 내에 답변 드리겠습니다.
              <!-- 라온 메타데미 담당자가 남겨주신 메일 주소로 신속하게 답변드릴
              예정입니다. -->
            </p>
            <!-- 여기에 접수일시 + 접수 시간 출력해야함. -->
          </div>
          <div class="btn_area" align="center">
            <a href="/" class="btn_basic">메인으로 이동</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ref, onMounted, computed } from 'vue';
import { onMounted } from 'vue'

export default {
  name: 'InquiryCompleteViews',
  components: {},
  setup() {
    onMounted(() => {})
    return {}
  },
}
</script>
